import { useState, useEffect } from "react";
import { Button, Stack, Wrap, WrapItem} from "@chakra-ui/react";
import { cameraService } from "../../services/cameraService";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { useTranslation } from "react-i18next";

const CameraPlacementsList = ({setCameraPlacementRef}) => {
    const [cameras, setCameras] = useState([]);
    const [placements, setPlacements] = useState([]);
    const showToast = useCustomToast();
    const {t} = useTranslation();

    const fetchData = async () => {
        try {
            const data = await cameraService.lookup();
            setCameras(data);
        } catch (err) {
            showToast({ title: t(err), status: "error" });
        }
    };

    const fetchCameraPlacement = async (id) => {
        const data = await cameraService.find(id);
        setPlacements(data.locais);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Stack
            alignSelf="flex-start"
            spacing="20px"
            direction={{ sm: "row", md: "column" }}
        >
            <Wrap spacing="10px" align="flex-start">
                {cameras.map((camera) => (
                    <WrapItem key={camera.id}>
                        <Button
                            w="100px"
                            h="35px"
                            variant="light"
                            bg="red.400"
                            _hover={{ bg: "gray.500" }}
                            onClick={() => { fetchCameraPlacement(camera.id); }}
                        >
                            {camera.nome}
                        </Button>
                    </WrapItem>
                ))}
            </Wrap>

            <Wrap spacing="10px" align="flex-start">
                {placements.map((placement) => (
                    <Button
                        key={placement}
                        variant="light"
                        w="100px"
                        h="35px"
                        bg="blue.400"
                        hover={{ bg: "grey.500" }}
                        onClick={() => setCameraPlacementRef(placement.nome)}
                    >
                        {placement.nome}
                    </Button>
                ))}
            </Wrap>
        </Stack>
    );
};

export default CameraPlacementsList;